import { useCallback } from "react";

import { isPreorderExcludedForBrandPromo } from "./isPreorderExcludedForBrandPromo";

export const useIsPreOrderExcludedForBrandPromo = () => {
  return useCallback(
    (...args: Parameters<typeof isPreorderExcludedForBrandPromo>) =>
      isPreorderExcludedForBrandPromo(...args),
    []
  );
};
